export default {
  PDFButtonFab: {
    baixar: 'Baixar',
    enviarEmail: 'Enviar por email',
    baixarPDF: 'Baixar PDF',
    baixarXLS: 'Baixar XLS',
    baixando: 'Baixando'
  }
};
